const metaFieldIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 13.3171C3.58537 12.7513 4.044 12.2927 4.60976 12.2927H16.3902C16.956 12.2927 17.4146 12.7513 17.4146 13.3171C17.4146 13.8828 16.956 14.3415 16.3902 14.3415H4.60976C4.044 14.3415 3.58537 13.8828 3.58537 13.3171Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 16.9024C3.58537 16.3367 4.044 15.878 4.60976 15.878H16.3902C16.956 15.878 17.4146 16.3367 17.4146 16.9024C17.4146 17.4682 16.956 17.9268 16.3902 17.9268H4.60976C4.044 17.9268 3.58537 17.4682 3.58537 16.9024Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 4.09756C3.58537 3.53181 4.044 3.07317 4.60976 3.07317H10.2439C10.8097 3.07317 11.2683 3.53181 11.2683 4.09756C11.2683 4.66332 10.8097 5.12195 10.2439 5.12195H4.60976C4.044 5.12195 3.58537 4.66332 3.58537 4.09756Z"
      fill="#6B00DF"
    />
    <path
      d="M3.58537 6.65854H4.54353L5.55552 9.41159H5.59859L6.61058 6.65854H7.56874V10.7561H6.81513V8.08908H6.78463L5.83364 10.7361H5.32047L4.36948 8.07908H4.33898V10.7561H3.58537V6.65854Z"
      fill="#6B00DF"
    />
    <path
      d="M8.15834 10.7561V6.65854H10.6345V7.37281H8.93528V8.34918H10.5071V9.06345H8.93528V10.0418H10.6417V10.7561H8.15834Z"
      fill="#6B00DF"
    />
    <path
      d="M11.0617 7.37281V6.65854H14.0797V7.37281H12.9547V10.7561H12.1867V7.37281H11.0617Z"
      fill="#6B00DF"
    />
    <path
      d="M14.7106 10.7561H13.878L15.1466 6.65854H16.1478L17.4146 10.7561H16.5821L15.6616 7.59489H15.6329L14.7106 10.7561ZM14.6586 9.14548H16.6251V9.82174H14.6586V9.14548Z"
      fill="#6B00DF"
    />
  </svg>
);

export default metaFieldIcon;
